interface FieldConfig {
  fieldType: string;
  lang: string;
  isSameValue?: boolean; // Optional property
  formatToNumber?: boolean; // Optional property
}

// Define the configuration object with the correct types

export enum commonFieldTypes {
  text = 'text',
  textarea = 'textarea',
  image = 'image',
  number = 'number',
  dropdown = 'dropdown',
  media = 'media',
}
export const commonFieldConfig: Record<string, Record<string, FieldConfig>> = {
  en: {
    text: {
      fieldType: commonFieldTypes.text,
      lang: 'en',
    },
    textarea: {
      fieldType: commonFieldTypes.textarea,
      lang: 'en',
    },
    image: {
      fieldType: commonFieldTypes.image,
      lang: 'en',
      isSameValue: true, // Optional 'isSameValue' only for image fields
    },
    media: {
      fieldType: commonFieldTypes.media,
      lang: 'en',
      isSameValue: true, // Optional 'isSameValue' only for image fields
    },
    number: {
      fieldType: commonFieldTypes.text,
      lang: 'en',
      isSameValue: true, // Optional 'isSameValue' only for image fields
      formatToNumber: true,
    },
    dropdown: {
      fieldType: commonFieldTypes.dropdown,
      lang: 'en',
      isSameValue: true, // Optional 'isSameValue' only for image fields
    },
  },
  ar: {
    text: {
      fieldType: commonFieldTypes.text,
      lang: 'ar',
    },
    textarea: {
      fieldType: commonFieldTypes.textarea,
      lang: 'ar',
    },
    image: {
      fieldType: commonFieldTypes.image,
      lang: 'ar',
      isSameValue: true, // Optional 'isSameValue' only for image fields
    },
  },
};
